/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, lazy, Suspense } from "react";

const CivilSpaceEngagement = lazy(() => import("./zencity-engagement"));

const CivilSpaceComponent = (props) => {

    const component = props?.component;

    return (
        <Fragment>
            <div>
                <Suspense fallback={<div>Loading...</div>}>
                    <CivilSpaceEngagement component={component} />
                </Suspense>
            </div>
        </Fragment>
    );
};

export { CivilSpaceComponent };

// https://dnv.civilspace.io/en/projects/154/discussion_topics/57?embed&origin=https://local.simplicitycms.ca:3300&iframe=0&utm_medium=embed
// https://dnv.civilspace.io/en/projects/154/discussion_topics/57?embed

